module.exports = __webpack_public_path__ + "img/OT495.85cc4ea.jpg";